import { createSelector } from 'reselect';
import get from 'lodash/get';

import { makeSelectorFactory } from '../../utils/redux/selectAdapter';

export const selectAppointmentsState = state => get(state, 'appointments');

export const selectAppointmentsMainState = state =>
  get(state, 'appointmentsState');

export const selectCurrentAppointment = createSelector(
  selectAppointmentsState,
  state => get(state, 'data', null),
);

export const selectCurrentAppointmentId = createSelector(
  selectCurrentAppointment,
  state => get(state, 'status.id', null),
);

/**
 *  APPOINTMENT ACCOUNT FORM PAYMENT
 * */

const getAppointmentAccountFormPaymentSelectors = makeSelectorFactory(
  selectAppointmentsMainState,
);

export const {
  selectStatePending: selectAppointmentAccountFormPaymentSending,
} = getAppointmentAccountFormPaymentSelectors('appointmentAccountFormPayment');



// WEBPACK FOOTER //
// ./src/redux/appointmnents/selectors.js